(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-addon"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    window.PXUTheme.theme_settings.cart_action_type === 'ajax' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    window.PXUTheme.cartDrawer && window.PXUTheme.cartDrawer.loadDrawer(true);
  });

  document.addEventListener('product-form:message:success', (event) => {
    event.preventDefault();
  });

  document.addEventListener('product-form:cart:update', (event) => {
    const { item_count } = event.detail.cart;
    window.PXUTheme.cartDrawer && window.PXUTheme.cartDrawer.updateCartCount(item_count);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    window.PXUTheme.theme_settings.cart_action_type === 'ajax' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    window.PXUTheme.cartDrawer && window.PXUTheme.cartDrawer.loadDrawer(true);
  });

  document.addEventListener('product-form:message:success', (event) => {
    event.preventDefault();
  });

  document.addEventListener('product-form:cart:update', (event) => {
    const { item_count } = event.detail.cart;
    window.PXUTheme.cartDrawer && window.PXUTheme.cartDrawer.updateCartCount(item_count);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-hotshot-mat"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    window.PXUTheme.theme_settings.cart_action_type === 'ajax' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    window.PXUTheme.cartDrawer && window.PXUTheme.cartDrawer.loadDrawer(true);
  });

  document.addEventListener('product-form:message:success', (event) => {
    event.preventDefault();
  });

  document.addEventListener('product-form:cart:update', (event) => {
    const { item_count } = event.detail.cart;
    window.PXUTheme.cartDrawer && window.PXUTheme.cartDrawer.updateCartCount(item_count);
  });

  document.addEventListener('DOMContentLoaded', function() {
    const largeSelects = document.querySelectorAll('.variant-select-large');
    largeSelects.forEach(select => {
      select.addEventListener('focus', function() {
        this.style.borderColor = 'var(--mv-accent)';
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-multi-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    window.PXUTheme.theme_settings.cart_action_type === 'ajax' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    window.PXUTheme.cartDrawer && window.PXUTheme.cartDrawer.loadDrawer(true);
  });

  document.addEventListener('product-form:message:success', (event) => {
    event.preventDefault();
  });

  document.addEventListener('product-form:cart:update', (event) => {
    const { item_count } = event.detail.cart;
    window.PXUTheme.cartDrawer && window.PXUTheme.cartDrawer.updateCartCount(item_count);
  });

  // Enhanced variant selection for multi-variant products
  document.addEventListener('DOMContentLoaded', function() {
    // Auto-scroll to selected option in large dropdowns
    const largeSelects = document.querySelectorAll('.variant-select-large');
    largeSelects.forEach(select => {
      select.addEventListener('focus', function() {
        // Highlight current selection
        this.style.borderColor = 'var(--mv-accent)';
      });
    });
  });

  // SportScreen parity — emphasise the smart-home badge when "Remote Control" is selected.
  // Server-side Liquid sets the correct state on load and on every buy-box re-render;
  // this delegated listener gives instant feedback in the moment before that re-render.
  (function () {
    function syncSmartHome() {
      var badge = document.querySelector('.ss-parity [data-smart-home]');
      if (!badge) return;
      var form = badge.closest('form') || document.querySelector('form[action*="/cart/add"]');
      var vals = '';
      if (form) {
        form.querySelectorAll('input:checked, select').forEach(function (el) {
          if (el.value) { vals += ' ' + el.value; }
        });
      }
      badge.classList.toggle('is-active', vals.toLowerCase().indexOf('remote') > -1);
    }
    document.addEventListener('change', syncSmartHome);
    document.addEventListener('DOMContentLoaded', syncSmartHome);
  })();

  } catch(e) { console.error(e); }
})();
})();
